import { autoinject } from 'aurelia-framework';

@autoinject
export class ThemeService {
  constructor() {
    import(`../scss/styles-${this.darkTheme ? 'dark' : 'light'}.scss`);
  }

  darkTheme: boolean = this.isDarkTheme();

  async loadTheme(dark: boolean) {
    if (dark === this.darkTheme) {
      return;
    }
    localStorage.setItem('dark-theme', dark.toString());
    window.location.reload();
  }

  isDarkTheme() {
    // return (localStorage.getItem('dark-theme') ?? (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches.toString())) === 'true';
    return (localStorage.getItem('dark-theme') ?? 'true') === 'true';
  }

  getChartLabelColour(labelColour?: string) {
    return labelColour ?? (this.darkTheme ? '#ffffff' : '#031D44');
  }

}

